export function SmallContainer({ children } : { children: React.ReactNode }) {
  return <div className="small-container">
    { children }
  </div>
}